import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { SetDocumentTypeResponse } from './setDocumentType';

export interface SetDocumentTypeViewedParams {
  documentId: string;
  isNew: boolean;
  isViewed: boolean;
}

const setDocumentTypeViewed: MutationFunction<
  SetDocumentTypeResponse,
  SetDocumentTypeViewedParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockType);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<SetDocumentTypeResponse>(
    `/documents/${args.documentId}`,
    {
      method: 'PUT',
      body: {
        isNew: args.isNew,
        isViewed: args.isViewed,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to set document type');
};

export default setDocumentTypeViewed;

const _mockType = {
  document: {
    id: 'mock-document-id',
    document_type_id: 'mock-document-type-id',
    loan_id: 'mock-loan-id',
  },
};
